let config = {
  /** multibook base parameters */
  realWidth: 1920,
  realHeight: 2576,
  /**
   * because we have to apply scaling and there are differences in the PDF and screen proportions we need to manually set all three parameters
   */

  /** is set for scaling in X axis icons, rectagles itd */
  mainContenPageCapacity: 90,
  /** is set for scaling width background image for pages */
  mainContenWidth: 770,
  /** is set for scaling height background image for pages */
  mainContenHeight: (1080 * 85) / 100,
  /** Offsets for rectangle in multibook rectangle */
  rectangleOffset: {
    x: -12,
    y: -12,
    width: 12,
    height: 12,
  },
  /** THIS PART IS NOT CHANGE SO OFFTEN */
  /** base  font type*/
  baseFont: 'Myriad Pro',
  /** show development bar - use in WWW (IRON ANT) */
  showDevlopmentBar: false,
  /** show standalone only icons in footer bar (Full Screnn, Zoom In) */
  showElectronOnlyIcons: process.env.IS_WEB || process.env.VUE_APP_IS_WEB ? false : true,
  isWeb: process.env.VUE_APP_IS_WEB && process.env.VUE_APP_IS_WEB != 'false' ? true : false,
  /** flag for notification about cache status in PWA */
  cacheStatus: false,
  /** disabe bookIndex */
  bookIndexDisable: true,
  /** disabe index before name in multibook list in multiconfig*/
  multibookListIndexShow: true,
  /** show DEV TOOL menu */
  // devTool: process.env.VUE_APP_DEVTOOL?.toLowerCase() == 'true' ? true : false,
  devTool: true,
};
export default config;
